import * as React from 'react';
import "./RadioElement.scss";
import { useCallback, useEffect, useState } from 'react';
import { ElementType } from '../../common/enum/elementType';
import InputElement from '../core/InputElement';
import { RadioProps, RadioDefines, RadioItemDefines } from './IRadio';
import { ColorDefines } from '../../interface/IColors';

interface RadioElementProps {
  props: RadioProps;
  defines: RadioDefines;
  colors: ColorDefines;
}

interface RadioItemDataProps {
  name: string;
  label: string;
}

const RadioElement = ({ props, defines, colors }: RadioElementProps) => {
  const [touched, setTouched] = useState(false);
  const [focus, setFocus] = useState<number>();
  const getLabelByItems = useCallback((value: string) => {
    return defines.items.find(item => item.value == value)?.label || "";
  }, [defines.items]);
  const [value, setValue] = useState<RadioItemDataProps>({
    label: getLabelByItems(props.value || defines.defaultValue),
    name: props.value || defines.defaultValue
  });

  useEffect(() => {
    const v = props.value || defines.defaultValue;
    setValue({
      label: getLabelByItems(v),
      name: v
    });
  }, [defines.defaultValue])

  const change = (item: RadioItemDefines) => {
    setTouched(true);
    if (props.setTouched) props.setTouched(true);
    setValue({ name: item.value, label: item.label });
  }
  
  return (
    <InputElement
      type={ElementType.RADIO}
      value={value?.name}
      touched={touched}
      dispatchValid={props.dispatchValid}
      {...{ props, defines }}
    >
      <div className={"items" + (focus != null ? " focus" : "")}>
        {defines.items.map((item, i) => (
          <label key={i} className={(value.name == item.value ? "selected" : (value == undefined ? "" : "not-selected")) + (focus == i ? " focus" : "")}>
            <input
              type="radio"
              name={defines.name}
              checked={item.value === value.name}
              onFocus={_ => setFocus(i)}
              onBlur={_ => setFocus(undefined)}
              onChange={_ => change(item)} />
            {item.label}
          </label>
        ))}
      </div>
    </InputElement>
  );
}

export default RadioElement;